import React from 'react';
import { NodeViewWrapper } from '@tiptap/react';
import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box';

const BookmarkComponent = ({ node }) => {
	const attribute = node?.attrs;
	//React Component of Tooltip wrapper with Bookmark Tag
	const code = attribute?.code;
	const display = attribute?.display;
	const value = attribute?.value;
	const hidden = attribute?.hidden === 'true';
	const exdconc = attribute?.exdconc === 'true';
	return (
		<NodeViewWrapper as="span" data-testid="Bookmark-Tag" style={{ display: hidden ? 'none' : 'visible' }}>
			<Tooltip role="tooltip" title={attribute?.display}>
				<Box
					component="span"
					contentEditable={false}
					data-code={code}
					data-display={display}
					data-exd-conc={exdconc}
					data-type="bookmark"
					data-value={value}
				>
					{value ?? display}
				</Box>
			</Tooltip>
		</NodeViewWrapper>
	);
};

export default BookmarkComponent;
